<template>
  <div class="profileContainer">
    <profile-component />
  </div>
</template>

<script>
import ProfileComponent from "../../../components/b2b/hyundai/ProfileComponent";

export default {
  name: "hyundaiProfile",
  components: {ProfileComponent},
}
</script>

<style scoped>
.profileContainer {
  font-family: 'HDharmony', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #D2D2D2;
}

</style>
